import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import AbstractReactComponent from '../AbstractReactComponent';
import {storeFromArea} from '../utils';
import {clearMessages} from './FrameActions';

const ie9 = navigator.userAgent.indexOf('MSIE 9.0') >= 0;

/**
 * IFrame komponenta s možností vzájemné komunikace.
 */
class Frame extends AbstractReactComponent {

    static PropTypes = {
        src: React.PropTypes.string.isRequired,
        area: React.PropTypes.string.isRequired,
        frame: React.PropTypes.object.isRequired,
        onMessage: React.PropTypes.func.isRequired,
    };

    static defaultProps = {
        // area: null,
    };

    _postMessage(data) {
        const dataForSend = ie9 ? JSON.stringify(data) : data;  // IE9 podporuje pouze string data => serializace
        const frame = ReactDOM.findDOMNode(this.refs.frame);
        frame.contentWindow.postMessage(dataForSend, '*');
    }

    handleMessage = (e) => {
        const {src, onMessage} = this.props;
        if (src && src.indexOf(e.origin) === 0) {
            // Zprava mohla prijit i od jineho window, musime kontrolovat origin
            const data = ie9 ? JSON.parse(e.data) : e.data; // IE9 podporuje pouze string data => serializace
            onMessage(data);
        }
    };

    componentDidMount() {
        window.addEventListener('message', this.handleMessage);
        this.processMessagesIfNeeded(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.processMessagesIfNeeded(nextProps);
    }

    processMessagesIfNeeded = (props) => {
        const {area, frame: {postSuspended, messages}} = props;
        if (!postSuspended && messages && messages.length > 0) {
            messages.forEach(msg => {
                this._postMessage(msg);
            });
            this.dispatch(clearMessages(area));
        }
    };

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
    }

    render() {
        const {src, area, frame, onMessage, dispatch, ...otherProps} = this.props;
        return (
            <iframe ref="frame" src={src} {...otherProps}></iframe>
        )
    }
}

function mapStateToProps(state, props) {
    return {
        frame: storeFromArea(state, props.area)
    };
}

export default connect(mapStateToProps)(Frame);
